<template>
  <div
    id="addBadge"
    class="tab-pane "
    role="tabpanel"
  >
    <!-- .name -->
    <b-form-group
      id="input-group-1"
      :label="$t('languages.name')"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="newItem.name"
        type="text"
        :placeholder="$t('languages.name')"
      />
    </b-form-group>
    <!-- .code -->
    <b-form-group
      id="input-group-2"
      :label="$t('languages.code')"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="newItem.code"
        type="text"
        :placeholder="$t('languages.code')"
      />
    </b-form-group>
    <!-- .active -->
    <b-form-group
      id="input-group-3"
      :label="$t('languages.active')"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        v-model="newItem.active"
        type="text"
        :placeholder="$t('languages.active')"
      />
    </b-form-group>

    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        @click="submit()"
      >
        <i class="fa fa-plus" /> {{ $t('site.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import Controller from '../../../../Controllers/LanguagesController'
import config from '../../../../config/config'

const controller = new Controller()
export default {
  name: 'LanguagesForm',
  components: {
    Select2,
  },
  props: ['newItem'],
  data() {
    return {
      file: {},
      

    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
